/**
 * [2026-09-26] - SD - Keeps the cart drawer's rental dates.
 *
 * The fields themselves are the browser's own date inputs (see
 * snippets/rental-date-fields.liquid), so there is no picker library to load
 * here any more.
 *
 * What is still needed: cart-drawer.js replaces the whole .drawer__inner on every
 * add/quantity change, which would wipe anything typed into the fields. So the values
 * are written back to cart attributes, and the snippet re-reads them from
 * cart.attributes on the next render.
 */
(function () {
  'use strict';

  var CONTAINER_SELECTOR = '[data-rental-dates]';
  var FIELD_SELECTOR = '[data-rental-dates] input[name^="attributes["]';

  // Delay before the picked dates are written back to the cart as attributes.
  var SAVE_DELAY = 300;

  var saveTimer = null;

  // Writes the current field values back to the cart so the drawer re-render
  // restores them from cart.attributes.
  function saveDates(container) {
    if (!container || typeof window.fetch !== 'function') return;

    var url = container.getAttribute('data-cart-update-url');
    if (!url) return;

    var attributes = {};
    var fields = container.querySelectorAll('input[name^="attributes["]');

    for (var i = 0; i < fields.length; i++) {
      var name = fields[i].getAttribute('name') || '';
      if (name.charAt(name.length - 1) !== ']') continue;
      // null clears the attribute when a date is emptied out again.
      attributes[name.slice('attributes['.length, -1)] = fields[i].value || null;
    }

    window.clearTimeout(saveTimer);
    saveTimer = window.setTimeout(function () {
      window
        .fetch(url, {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({ attributes: attributes })
        })
        .then(function (response) {
          if (!response.ok) throw new Error('HTTP ' + response.status);
        })
        .catch(function (error) {
          // The value stays in the field, and the drawer form still carries it
          // to checkout, so this is recoverable.
          console.warn('[rental-drawer-dates] rental dates not saved:', error);
        });
    }, SAVE_DELAY);
  }

  // Delegated on the document so it keeps working after cart-drawer.js re-renders
  // the fields. The date inputs fire both "input" (while editing) and "change".
  function onFieldEdit(event) {
    var target = event.target;
    if (!target || typeof target.matches !== 'function') return;
    if (!target.matches(FIELD_SELECTOR)) return;
    saveDates(target.closest(CONTAINER_SELECTOR));
  }

  function start() {
    if (!document.querySelector(CONTAINER_SELECTOR)) return;

    document.addEventListener('change', onFieldEdit);
    document.addEventListener('input', onFieldEdit);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
